// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1RlcT","actionsCol":"EnrolledClinics_actionsCol__No6Ov"};